// User Access Utility Functions

/**
 * Check if user has access to the app
 * @param {object} user - User object
 * @returns {object} { hasAccess: boolean, shouldShowPending: boolean, errorMessage: string }
 */
export const checkUserAccess = (user) => {
  if (!user) {
    return {
      hasAccess: false,
      shouldShowPending: false,
      errorMessage: 'User data not found. Please login again.',
    };
  }

  const { user_status, user_type } = user;

  // Check if user type is PICKER or ADMIN
  const isValidUserType = user_type === 'PICKER' || user_type === 'ADMIN';

  // If user type is not PICKER or ADMIN, show error
  if (!isValidUserType) {
    const userTypeName = user_type || 'unknown';
    return {
      hasAccess: false,
      shouldShowPending: false,
      errorMessage: `This app is only for Pickers. Your account type is ${userTypeName}.`,
    };
  }

  // If user type is PICKER or ADMIN and status is NOT APPROVED, show pending page
  if (user_status === 'NOT APPROVED') {
    return {
      hasAccess: false,
      shouldShowPending: true,
      errorMessage: null,
    };
  }

  // For all other statuses (ACTIVE, INACTIVE, APPROVED, etc.), allow access
  // Only NOT APPROVED status requires approval pending
  return {
    hasAccess: true,
    shouldShowPending: false,
    errorMessage: null,
  };
};

